import {Action} from "@ngrx/store";
import {User} from "../models/user.model";

export const SET_USER = "[USER] set";
export const REMOVE_USER = "[USER] remove";
export const LOGIN = "[USER] login";
export const LOGOUT = "[USER] logout";

export class SetUser implements Action {
    readonly type = SET_USER;
    constructor(public payload: User){
    }
}

export class RemoveUser implements Action {
    readonly type = REMOVE_USER;
    constructor(){
    }
}

export class Login implements Action {
    readonly type = LOGIN;
    constructor(){
    }
}

export class Logout implements Action {
    readonly type = LOGOUT;
    constructor(){
    }
}

export type UserActions = SetUser | RemoveUser | Login | Logout;